import { AppNode, EdgeData } from "@features/builder/graph/types"
import { createEdgesLookup } from "@features/builder/NodeDrawer/NodeForm/GraphNav/createEdgesLookup"
import {
  getItemColor,
  removeChildEdge,
} from "@features/builder/NodeDrawer/NodeForm/GraphNav/helpers"
import NodeDrawerAccordion from "@features/builder/NodeDrawer/NodeDrawerAccordion"
import { IconButton, List, ListItem, ListItemText } from "@mui/material"
import { Edge, useEdges, useNodes, useReactFlow } from "@xyflow/react"
import { useMemo } from "react"
import { getSortedNodeLabelsById } from "@features/graph/utils/graphNodeUtils"
import { Remove } from "@mui/icons-material"
import { GraphNavAddEdge } from "@features/builder/NodeDrawer/NodeForm/GraphNav/GraphNavAddEdge"
import { useGoToNode } from "@features/builder/hooks/useGoToNode"

export const GraphNavChildrens = (props: { node: AppNode; disabled: boolean }) => {
  const reactFlowInstance = useReactFlow<AppNode, Edge<EdgeData>>()
  const nodes = useNodes<AppNode>()
  const edges = useEdges<Edge<EdgeData>>()
  const currentNodeId = props.node.id

  const lookup = useMemo(() => createEdgesLookup(edges), [edges])
  const children = lookup.parents[currentNodeId] ?? []
  const sortedChildrenLabels = getSortedNodeLabelsById(nodes, children)
  const goToNode = useGoToNode()

  const handleRemoveEdge = (id: string) => {
    removeChildEdge(id, props.node, nodes, reactFlowInstance)
  }

  return (
    <NodeDrawerAccordion id="graph-nav-childrens" label="Children:" expand={false}>
      <List sx={{ p: 0 }}>
        {sortedChildrenLabels.map(({ id, label }) => (
          <ListItem
            divider
            key={id}
            sx={{
              backgroundColor: getItemColor(id),
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "rgba(225, 225, 225, 0.4)",
              },
            }}
          >
            <ListItemText primary={label} onClick={() => goToNode(id)} />
            <IconButton disabled={props.disabled} onClick={() => handleRemoveEdge(id)}>
              <Remove />
            </IconButton>
          </ListItem>
        ))}
        <GraphNavAddEdge disabled={props.disabled} node={props.node} mode="children" />
      </List>
    </NodeDrawerAccordion>
  )
}
